import Hero from '../ckan/Herov2';
import Highlight from '../solutions/Highlight.jsx'
import ValuePropositions from '../ckan/ValuePropositions.jsx'
import SocialProof from '../ckan/SocialProof';
import Features from '../ckan/Features.jsx';
import MoreFeatures from './MoreFeatures';
import CenteredContent from './CenteredContent';
import Incentives from './Incentives';
import { ArrowNarrowRightIcon } from '@heroicons/react/outline'
import CaseStudiesSection from '../solutions/CaseStudiesSection';
import Blog from '../ckan/Blog';
import Link from 'next/link';

export default function OpenData({ blogs, casestudies }) {
  const values = [
    {
      title: "Easy publishing for non-technical staff",
      text: "Make publishing data openly an everyday activity for all types of staff in your organization.",
    },
    {
      title: "Foundation for your transparency initiatives",
      text: "Support transparency initiatives by releasing data on information such as taxes, public spending, and law enforcement.",
    },
    {
      title: "Central point of discovery",
      text: "Save time and enable innovation by making data accessible by UI and API.",
    },
    {
      title: "CKAN-based out-of-the-box solution",
      text: "Jumpstart your data management journey with a ready-to-use open data portal, minimizing setup time and complexity.",
    },
    {
      title: "Highly scalable and customizable",
      text: "Adapt and expand your open data portal with ease to meet your organization's evolving data needs and requirements.",
    },
    {
      title: "Budget-friendly and efficient",
      text: "Leverage a cost-effective solution that delivers exceptional value without compromising functionality or performance.",
    },
  ]

  const features = [
    {
      title: 'INTUITIVE USER EXPERIENCE',
      text: "Efficiently publish, search, and manage datasets with CKAN's user-friendly web interface, designed for users of all technical backgrounds.",
      icon: "/assets/icons/ebook.json"
    },
    {
      title: 'ADVANCED SEARCH FUNCTIONALITY',
      text: "Empower users to easily locate the data they need with CKAN's advanced ‘Google-style’ keyword search functionality, including faceted search and filtering options.",
      icon: "/assets/icons/magnify.json"
    },
    {
      title: 'EXCEPTIONAL FLEXIBILITY',
      text: "Leverage CKAN's modular design to effortlessly integrate custom features, extensions, and enhancements for a tailored data management solution.",
      icon: "/assets/icons/hexagonal.json"
    },
    {
      title: 'SCALABILITY AT ITS CORE',
      text: "Confidently handle vast amounts of data with CKAN's scalable architecture, designed to meet the needs of diverse organizations.",
      icon: "/assets/icons/views.json"
    },
    {
      title: 'ROBUST API CAPABILITIES',
      text: "Unlock CKAN's powerful API potential to develop tailored applications and seamlessly integrate with external systems.",
      icon: "/assets/icons/robustapi.json"
    },
    {
      title: 'COMPREHENSIVE METADATA SUPPORT',
      text: "Enhance discoverability with CKAN's extensive metadata support, ensuring your datasets are well-documented and easily accessible.",
      icon: "/assets/icons/tag.json"
    },
    {
      title: 'DATA VISUALIZATION MASTERY',
      text: "Harness built-in visualization tools and integrate external libraries to transform raw data into actionable insights.",
      icon: "/assets/icons/bar-chart.json"
    },
    {
      title: 'GRANULAR ACCESS CONTROL',
      text: "Safeguard your data with precise access control features, empowering administrators to manage user permissions effectively.",
      icon: "/assets/icons/keys.json"
    },

    {
      title: 'SECURE AND RELIABLE',
      text: "Trust in CKAN's robust security measures and reliable infrastructure, safeguarding your data and providing peace of mind for your organization.",
      icon: "/assets/icons/online-security.json"
    },
    {
      title: 'CLOUD AND ON-PREMISE DEPLOYMENT',
      text: "Choose the deployment model that suits your organization best, with support for both cloud-based and on-premise installations.",
      icon: "/assets/icons/hard-drive.json"
    },
    {
      title: 'ONGOING SUPPORT AND MAINTENANCE',
      text: "Rely on CKAN's dedicated support network for ongoing assistance, updates, and maintenance, ensuring a stable and optimized open data platform.",
      icon: "/assets/icons/tech-support.json"
    },
    {
      title: 'VIBRANT DEVELOPER COMMUNITY',
      text: "Benefit from a dedicated and active community of developers, users, and organizations that contribute to CKAN's growth and offer invaluable support.",
      icon: "/assets/icons/happy.json"
    },
    {
      title: 'OPEN-SOURCE COMMUNITY',
      text: "Experience the power of a thriving open-source community that fosters innovation and adaptation, ensuring CKAN evolves to meet your organization's needs.",
      icon: "/assets/icons/humanitarian.json"
    },
    {
      title: 'TRUSTED BY THE BEST',
      text: "Join the ranks of renowned governments, NGOs, and private organizations worldwide that have chosen CKAN for their open data initiatives.",
      icon: "/assets/icons/handshake.json"
    },
  ]
  return (
    <section className='!overflow-x-hidden'>
      <section className="bg-cover bg-odpHero bg-odpPosition bg-no-repeat "
      >
        <section>
          <Hero topTitle="Open Data Portals" title="Publish data properly. Empower your citizens." subtitle="Compliance. Transparency. Innovation. Whatever your reason for publishing data to the world, you want a data portal." />
        </section>

        <section className='pt-8'>
          <SocialProof />
        </section>

        <section>
          <section className=' relative w-screen max-w-screen overflow-hidden lg:flex-row bg-gradient-to-b from-transparent to-[#F7F8F9]'>
            <Highlight subtitle="WE KNOW HOW TO BUILD DATA PORTALS" topTitle="We built CKAN and the world’s first data portals"
              text="Our team is proud to be led by the creator of <a href='https://ckan.org/' target='_blank'><span>CKAN</span></a> himself, <a href='https://rufuspollock.com/' target='_blank'><span>Dr. Rufus Pollock</span></a>, 
            president at Datopian. We built <a href='https://ckan.org/' target='_blank'><span>CKAN</span></a>, the world's leading open-source data management platform and the world's first portals
             for publishing open data such as <a href='https://data.gov/' target='_blank'><span>data.gov</span></a> and <a href='https://data.gov.uk/' target='_blank'><span>data.gov.uk</span></a>. We have successfully deployed dozens of projects for government, Fortune 500 enterprises, and international NGOs. "
            />
            <Highlight subtitle="NEXT-GEN DATA PORTALS" topTitle="Uniting CKAN's power with modern frontend excellence"
              text="Using our innovative next-generation approach to architecting data portals we can combine <a href='https://ckan.org/' target='_blank'><span>CKAN</span></a> with the latest frontend technologies to give the best of both worlds:
           a powerful data catalog backend combined with a rich, modern frontend experience. A platform that is upgraded and maintained easily and easy to use for the end user."
              reverse
            />
          </section>
        </section>
      </section>
      <section >
        <section >
          <CenteredContent />
        </section>

        <section >
          <Incentives />
        </section>

        <section >
          <ValuePropositions topTitle="Democratizing the power of data" title="Our solution offers a seamless experience for the preparation, publication, and analysis of open data, for both internal stakeholders and the public at large. Go beyond the open data portal and publish with purpose using value-added services for fine-grained access, quality assessment, data enrichment, personal data de-identification, and more."
            valuePropositions={values} />
        </section>

        <section >
          <Features topTitle="What makes CKAN so popular for open data?" title="CKAN is the go-to choice for open data, empowering organizations worldwide to harness its power and versatility. Simplifying data sharing, fostering transparency, and boosting collaboration. Flexible. Scalable. User-friendly." featuredItems={features} />
        </section>

        <section >
          <MoreFeatures />
        </section>

        <section>
          <CaseStudiesSection blogs={casestudies} subtitle="OPEN DATA PORTAL" catalog="open-data" />
        </section>


        <section className='bg-white py-20 relative w-screen max-w-screen overflow-hidden' tabIndex={0}>
          <h3 className='text-center mx-auto medium-title font-["Inter"] text-white'>We are the CKAN experts.</h3>
          <p className='text-center font-["Inter"] text-maingray mt-4 px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>Datopian are the co-creators, co-stewards, and one of the main developers of CKAN. We design, develop and scale CKAN solutions for everyone from government to the Fortune 500. We also monitor client use cases for data to ensure that CKAN is responding
            to genuine challenges faced by real organizations.</p>
          <div className='flex flex-col  sm:flex-row mt-8 gap-y-8 sm:gap-x-8 w-full justify-center px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>
            <div className='btn-primary'><Link href="/contact">Email us</Link></div>
            <div className='btn-primary'><Link href="https://calendar.app.google/LT4acVdKn3Cxm2MXA" target="_blank">Schedule a free call</Link></div>
          </div>
        </section>

        <section >
          <Blog blogs={blogs} />
        </section>

      </section>
    </section >
  );
}